"use client";
import { builder } from "@builder.io/react";
import { registerAccordionComponents } from "./builder/accordion";
import { registerCalculatorComponents } from "./builder/calculator";
import { registerCareerComponents } from "./builder/other";
import { registerCompareComponents } from "./builder/compare";
import { registerCtaComponents } from "./builder/cta";
import { registerElementsComponents } from "./builder/elements";
import { registerFeatureComponents } from "./builder/features";
import { registerFormComponents } from "./builder/form";
import { registerGalleryComponents } from "./builder/gallery";
import { registerHeroComponents } from "./builder/heros";
import { registerListingComponents } from "./builder/listing";
import { registerPageComponents } from "./builder/page";
import { registerSectionComponents } from "./builder/section";
import { registerStatsComponents } from "./builder/stats";
import { registerTestimonialComponents } from "./builder/testimonial";

builder.init(process.env.NEXT_PUBLIC_BUILDER_API_KEY!);

// Register page components
registerPageComponents();
// Register hero components
registerHeroComponents();
// Register elements components
registerElementsComponents();
// Register features components
registerFeatureComponents();
// Register testimonial components
registerTestimonialComponents();
// Register gallery components
registerGalleryComponents();
// Register stats components
registerStatsComponents();
// Register faq components
registerAccordionComponents();
// Register cta components
registerCtaComponents();
// Register listing components
registerListingComponents();
// Register section components
registerSectionComponents();
// Register compare components
registerCompareComponents();
// Register career components
registerCareerComponents();
// Register form components
registerFormComponents();
// Register calculator components
registerCalculatorComponents();
